"use client";

import { AuthAlternative } from "@/components/layout/auth-alternative";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSignIn } from "@/hooks/provider/use-sign-in";

export function InputSection() {
  const { loading, setEmail, setPassword, signIn, disabled } = useSignIn();

  return (
    <div className="flex flex-col gap-5">
      <Input
        placeholder="이메일을 입력해주세요"
        label="이메일"
        required
        onChange={setEmail}
      />
      <Input
        placeholder="비밀번호을 입력해주세요"
        label="비밀번호"
        required
        onChange={setPassword}
        type="password"
        onEnter={signIn}
      />
      <div className="flex flex-col gap-6 w-full">
        <Button
          size="lg"
          className="w-full"
          disabled={disabled}
          loading={loading}
          onClick={signIn}
        >
          로그인하기
        </Button>
        <AuthAlternative
          leadText="아직 계정이 없나요?"
          cta={{
            href: "/sign-up",
            text: "회원가입",
          }}
        />
      </div>
    </div>
  );
}
